import React, { FC } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig, selectNcFileData } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { NCFileTraceabilityContent } from '@v2/pages/common/components/NCFileTraceabilityContent';
import { DETAILS_SCREENS_CONTAINER_STYLES } from '@v2/pages/common/constants/base.constants';

const NCFileDetailsNCFileTraceability: FC = () => {
  const dispatch = useAppDispatch();
  const ncFileData = useSelector(selectNcFileData);
  const title = useTitle();

  // Runs the NC-file perspective loader so the header is populated; the graph content
  // below fetches its own data off the resolved anchor id.
  const { ncFileId } = useNCFileDetails({
    clearTools: () => dispatch(clearTools()),
    getNCFileById: (id) => dispatch(getNCFileById(id)),
    getTools: (params) => dispatch(getTools(params)),
    getProductionBatchByNCFile: (params) => dispatch(getProductionBatchByNCFile(params)),
    updateHeaderConfig: (config) => dispatch(updateHeaderConfig(config)),
    operationsSearch: (params) => dispatch(operationsSearch(params)),
    getNCFileByName: (name, select) => dispatch(getNCFileByName(name, select)),
    loadAllJobs: true,
  });

  const anchorNcFileId = ncFileData.data?.ncFileId ?? ncFileId ?? null;

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <View style={DETAILS_SCREENS_CONTAINER_STYLES}>
        <NCFileTraceabilityContent ncFileId={anchorNcFileId} resolving={!ncFileData.wasLoaded && !ncFileId} />
      </View>
    </DetailsPageWrapper>
  );
};

export { NCFileDetailsNCFileTraceability };
